import React from 'react';
import PropTypes from 'prop-types';
import endsWith from 'lodash/endsWith';

import {
  ExtendedBox,
  Heading,
  Data,
  Tooltip,
  TooltipIcon,
  Body,
} from '../../coreui';

const HeaderHighlight = ({
  highlight,
  label,
  tooltip,
  id,
  showAsterisk,
  ...passedProps
}) => {
  if (highlight) {
    return (
      <ExtendedBox
        ml={[5, 10, 10, 10, 25]}
        width={[110, 150, 150, 150, 180]}
        textAlign="center"
        // eslint-disable-next-line
        {...passedProps}
      >
        <Heading
          type="H3"
          display="block"
          m={0}
          color="blue.1"
          letterSpacing="-1.4px"
        >
          {highlight}
          {
            showAsterisk && !endsWith(highlight, '*') &&
            '*'
          }
        </Heading>
        <hr />
        <Data
          type="D4"
        >
          {label}
        </Data>
        <HeaderTooltip
          id={id}
          tt={tooltip}
        />
      </ExtendedBox>
    );
  }
  return null;
};

const HeaderTooltip = ({
  id,
  tt,
}) => {
  return (
    <ExtendedBox
      mt={5}
    >
      <TooltipIcon
        tooltipId={`${id}-tooltip`}
        m="auto"
        display="inline-block"
      />
      <Tooltip
        id={`${id}-tooltip`}
        multiline
        place="bottom"
      >
        <ExtendedBox
          textAlign="left"
          m="auto"
        >
          <Body
            type="B5"
            mb={20}
            color="gray.8"
          >
            {tt.tooltip}
          </Body>
          {
            tt.disclaimer &&
            <>
              <br />
              <br />
              <Data
                type="D3"
              >
                Disclaimer:
              </Data>
              <br />
              <Body
                type="B6"
                m={0}
                color="gray.8"
              >
                {tt.disclaimer}
              </Body>
            </>
          }
        </ExtendedBox>
      </Tooltip>
    </ExtendedBox>
  );
};

HeaderHighlight.propTypes = {
  highlight: PropTypes.string,
  label: PropTypes.any,
  tooltip: PropTypes.object,
  id: PropTypes.string,
  showAsterisk: PropTypes.bool,
};

HeaderTooltip.propTypes = {
  tt: PropTypes.object,
  id: PropTypes.string,
};

export default HeaderHighlight;
